import { render } from "./LoopScene.vue?vue&type=template&id=0915e11d&scoped=true"
import script from "./LoopScene.vue?vue&type=script&lang=js"
export * from "./LoopScene.vue?vue&type=script&lang=js"

import "./LoopScene.vue?vue&type=style&index=0&id=0915e11d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0915e11d"]])

export default __exports__